import { useEffect, useMemo, useState, useCallback } from "react";
import api from "@/lib/api";

function fmtDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function taskAppliesToDate(task, date) {
  if (task.recurring === "none") return task.date === date;
  if (task.recurring === "daily") return task.date <= date;
  const [Y, M, D] = date.split("-").map(Number);
  const dow = new Date(Y, M - 1, D).getDay();
  if (task.recurring === "weekly") {
    const [tY, tM, tD] = task.date.split("-").map(Number);
    const taskDow = new Date(tY, tM - 1, tD).getDay();
    return task.date <= date && dow === taskDow;
  }
  if (task.recurring === "weekdays") {
    return task.date <= date && dow >= 1 && dow <= 5;
  }
  return false;
}

export function taskCompletedOn(task, date) {
  if (task.recurring === "none") return !!task.completed;
  return Array.isArray(task.completed_dates) && task.completed_dates.includes(date);
}

// Hook returning today's checklist progress
export function useTodaysChecklist() {
  const todayKey = useMemo(() => fmtDate(new Date()), []);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/tasks", { params: { date: todayKey } });
      setTasks(data);
    } finally {
      setLoading(false);
    }
  }, [todayKey]);

  useEffect(() => {
    load();
  }, [load]);

  const visible = useMemo(
    () => tasks.filter((t) => taskAppliesToDate(t, todayKey)),
    [tasks, todayKey]
  );
  const done = visible.filter((t) => taskCompletedOn(t, todayKey)).length;
  const total = visible.length;
  const urgentOpen = visible.filter(
    (t) => !taskCompletedOn(t, todayKey) && t.urgency === "high"
  );

  return { tasks: visible, total, done, urgentOpen, todayKey, loading, refresh: load };
}

export { fmtDate };
